export const oldCompatibilityData = {
  Form: {
    active: false,
    visible: true,
    status: 'success',
    icon: 'fa fa-play',
    ui: 'Form',
    shape: { type: 'circle', width: 99, height: 99, selected: false },
  },
  Start: {
    active: false,
    visible: false,
    status: 'success',
    icon: 'fa fa-play',
    ui: 'Start',
    shape: { type: 'circle', width: 99, height: 99, selected: false },
  },
  Database: {
    active: false,
    visible: true,
    status: 'success',
    icon: 'fas fa-database',
    ui: 'Database',
    shape: { type: 'rectangle', width: 215, height: 72, selected: false },
  },
  End: {
    active: false,
    visible: true,
    status: 'success',
    icon: 'fa fa-check',
    ui: 'End',
    shape: { type: 'circle', width: 99, height: 99, selected: false },
  },
  Email: {
    active: false,
    visible: true,
    status: 'success',
    icon: 'fa fa-envelope',
    ui: 'Email',
    shape: { type: 'rectangle', width: 215, height: 72, selected: false },
  },
  Code: {
    active: false,
    visible: true,
    status: 'success',
    icon: 'fa fa-code',
    ui: 'Code',
    shape: { type: 'rectangle', width: 215, height: 72, selected: false },
  },
  HTML: {
    active: false,
    visible: true,
    icon: 'fas fa-file',
    status: 'success',
    ui: 'HTML',
    shape: { type: 'rectangle', width: 215, height: 72, selected: false },
  },
  API: {
    active: false,
    visible: true,
    status: 'success',
    icon: 'fa fa-plug',
    ui: 'API',
    shape: { type: 'rectangle', width: 215, height: 72, selected: false },
  },
  Condition: {
    active: false,
    visible: true,
    status: 'success',
    icon: require('../../assets/img/condition.svg'),
    ui: 'Condition',
    path: {
      truePath: true,
      falsePath: true,
    },
    shape: { type: 'rectangle', width: 215, height: 72, selected: false },
  },
  PageBuilder: {
    active: false,
    visible: true,
    status: 'success',
    icon: 'fas fa-chart-area',
    ui: 'Code',
    shape: { type: 'rectangle', width: 99, height: 99, selected: false },
  },
  Logic: {
    active: false,
    visible: true,
    status: 'success',
    icon: require('../../assets/img/logic.svg'),
    ui: 'Code',
    shape: { type: 'rectangle', width: 99, height: 99, selected: false },
  },
  Redirect: {
    active: false,
    visible: true,
    status: 'success',
    icon: 'fa fa-directions',
    ui: 'Redirect',
    shape: { type: 'circle', width: 99, height: 99, selected: false },
  },
  AskChatGPT: {
    active: false,
    visible: true,
    status: 'success',
    icon: require('../../assets/img/chatGPT.png'),
    ui: 'AskChatGPT',
    shape: { type: 'rectangle', width: 99, height: 99, selected: false },
  },
  JsonMapper: {
    active: false,
    visible: true,
    status: 'success',
    icon: 'fas fa-chart-area',
    ui: 'JsonMapper',
    shape: { type: 'rectangle', width: 99, height: 99, selected: false },
  },
  GetItem: {
    active: false,
    visible: true,
    status: 'success',
    icon: 'far fa-file-alt',
    ui: 'GetItem',
    shape: { type: 'rectangle', width: 215, height: 72, selected: false },
  },
  UpdateItem: {
    active: true,
    visible: true,
    status: 'success',
    icon: 'fas fa-edit',
    ui: 'UpdateItem',
    shape: { type: 'rectangle', width: 215, height: 72, selected: false },
  },
  RemoveItem: {
    active: false,
    visible: true,
    status: 'success',
    icon: 'far fa-file-alt',
    ui: 'RemoveItem',
    shape: { type: 'rectangle', width: 215, height: 72, selected: false },
  },
  AILogic: {
    active: false,
    visible: true,
    status: 'success',
    icon: 'fa fa-code',
    ui: 'Code',
    shape: { type: 'rectangle', width: 215, height: 72, selected: false },
  },
  SpreadSheet: {
    active: false,
    visible: true,
    status: 'success',
    icon: 'fa fa-code',
    ui: 'Code',
    shape: { type: 'rectangle', width: 215, height: 72, selected: false },
  },
};

export const workFlowTasks = [
  {
    id: 0,
    name: 'Form',
    caption: 'Formular',
    props: {
      trigger: 'formTrigger',
      timeTrigger: {
        freq: 'H',
        date: '01.03.2020',
        time: '08:00',
      },
      formTrigger: {
        id: null,
        title: null,
        Description: null,
        elements: [],
        structure: {
          tabs: [
            {
              id: 0,
              rows: [
                {
                  id: 0,
                  cols: [
                    {
                      id: 0,
                    },
                  ],
                },
              ],
            },
          ],
        },
        fullWidth: false,
      },
      eventTrigger: null,
      emailTrigger: null,
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['Form'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['Form'],
  },
  {
    id: 1,
    name: 'Start',
    caption: 'Formular',
    props: {
      trigger: 'formTrigger',
      timeTrigger: {
        freq: 'H',
        date: '01.03.2020',
        time: '08:00',
      },
      formTrigger: {
        id: null,
        title: null,
        Description: null,
        elements: [],
        structure: {
          tabs: [
            {
              id: 0,
              rows: [
                {
                  id: 0,
                  cols: [
                    {
                      id: 0,
                    },
                  ],
                },
              ],
            },
          ],
        },
        fullWidth: false,
      },
      eventTrigger: null,
      emailTrigger: null,
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['Start'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['Start'],
  },
  {
    id: 2,
    name: 'End',
    caption: 'Ende',
    props: {
      successURL: '',
      errorURL: '',
      successHTML: '',
      errorHTML: '',
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['End'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['End'],
  },
  {
    id: 3,
    name: 'Email',
    caption: 'E-Mail',
    props: {
      from: '',
      receiver: '',
      cc: '',
      bcc: '',
      subject: '',
      replyTo: '',
      message: '<br>',
      attachment: [],
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['Email'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['Email'],
  },
  {
    id: 4,
    name: 'Code',
    caption: 'Script',
    props: {
      code: "# Insert your code here \n# Or type '///' and i will write for you \n",
      language: 'py',
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
    },
    previousTaskId: null,
    ...oldCompatibilityData['Code'],
  },
  {
    id: 5,
    name: 'HTML',
    caption: 'HTML-Seite',
    props: {
      message: '',
      markdown: '',
      templateUrl: '',
      filename: 'Report',
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['HTML'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['HTML'],
  },
  {
    id: 6,
    name: 'API',
    caption: 'API',
    props: {
      api: null,
      version: null,
      path: {
        name: null,
        method: null,
      },
      filename: null,
      parameterData: null,
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['API'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['API'],
  },
  {
    id: 7,
    name: 'PageBuilder',
    caption: 'Page',
    props: { jsonContent: null, htmlContent: null, reportName: null },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['PageBuilder'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['PageBuilder'],
  },
  {
    id: 8,
    name: 'Logic',
    caption: 'Logik',
    props: { defaultStatementAndLogicNodes: null },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['Logic'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['Logic'],
  },
  {
    id: 9,
    name: 'Redirect',
    caption: 'Weiterleiten',
    props: {
      redirect: '',
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['Redirect'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['Redirect'],
  },
  {
    id: 10,
    name: 'AskChatGPT',
    caption: 'Frage KI',
    props: {
      prompt: null,
      chatGptTaskName: null,
      attachment: [],
      model: 'gpt-4',
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['AskChatGPT'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['AskChatGPT'],
  },
  {
    id: 11,
    name: 'JsonMapper',
    caption: 'Objekt erstellen',
    props: null,
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['JsonMapper'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['JsonMapper'],
  },
  {
    id: 12,
    name: 'Database',
    caption: 'Datensatz schreiben',
    props: {
      operation: null,
      database: null,
      item: {},
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['Database'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['Database'],
  },
  {
    id: 13,
    name: 'GetItem',
    caption: 'Datensatz abrufen',
    props: {
      database: null,
      userInputId: null,
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['GetItem'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['GetItem'],
  },
  {
    id: 14,
    name: 'UpdateItem',
    caption: 'Datensatz aktualisieren',
    props: {
      database: null,
      userInputItemId: null,
      itemContent: [],
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['UpdateItem'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['UpdateItem'],
  },
  {
    id: 15,
    name: 'RemoveItem',
    caption: 'Datensatz löschen',
    props: {
      database: null,
      userInputId: null,
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['RemoveItem'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['RemoveItem'],
  },
  {
    id: 16,
    name: 'Condition',
    caption: 'Entscheidung',
    props: { conditions: null },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['Condition'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['Condition'],
  },
  {
    id: 4,
    name: 'AILogic',
    caption: 'KI-Logik',
    props: {
      nodes: [],
      language: 'py',
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
    },
    previousTaskId: null,
    ...oldCompatibilityData['AILogic'],
    active: false,
    visible: true,
    status: 'success',
    icon: 'fa fa-code',
    ui: 'Code',
    shape: { type: 'rectangle', width: 215, height: 72, selected: false },
  },
  {
    id: 17,
    name: 'SpreadSheet',
    caption: 'SpreadSheet',
    props: {
      rows: 30,
      cols: 26,
      sheetData: {},
      resultList: [],
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['SpreadSheet'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['SpreadSheet'],
  },
];
export const workFlowTasksJsonV3 = [
  {
    id: 0,
    name: 'Form',
    caption: 'Formular',
    props: {
      settings: {
        btnCaption: 'Starten',
        layout: {
          spacing: 'standard',
        },
      },
      elements: [],
      structure: {
        tabs: [
          {
            label: 'Tab 1',
            rows: [],
          },
        ],
        layout: {},
      },
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
    },
    previousTaskId: null,
  },
  {
    id: 1,
    name: 'Start',
    caption: 'Formular',
    props: {
      settings: {
        btnCaption: 'Starten',
        layout: {
          spacing: 'standard',
        },
      },
      elements: [],
      structure: {
        tabs: [
          {
            label: 'Tab 1',
            rows: [],
          },
        ],
        layout: {},
      },
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
    },
    previousTaskId: null,
  },
  {
    id: 2,
    name: 'End',
    caption: 'Ende',
    props: {
      successURL: '',
      errorURL: '',
      successHTML: '',
      errorHTML: '',
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['End'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['End'],
  },
  {
    id: 3,
    name: 'Email',
    caption: 'E-Mail',
    props: {
      from: '',
      receiver: '',
      cc: '',
      bcc: '',
      subject: '',
      replyTo: '',
      message: '<br>',
      attachment: [],
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['Email'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['Email'],
  },
  {
    id: 4,
    name: 'Code',
    caption: 'Script',
    props: {
      code: "# Insert your code here \n# Or type '///' and i will write for you \n",
      language: 'py',
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
    },
    previousTaskId: null,
    ...oldCompatibilityData['Code'],
  },
  {
    id: 5,
    name: 'HTML',
    caption: 'HTML-Seite',
    props: {
      message: '',
      markdown: '',
      templateUrl: '',
      filename: 'Report',
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['HTML'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['HTML'],
  },
  {
    id: 6,
    name: 'API',
    caption: 'API',
    props: {
      api: null,
      version: null,
      path: {
        name: null,
        method: null,
      },
      filename: null,
      parameterData: null,
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['API'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['API'],
  },
  {
    id: 7,
    name: 'PageBuilder',
    caption: 'Page',
    props: { jsonContent: null, htmlContent: null, reportName: null },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['PageBuilder'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['PageBuilder'],
  },
  {
    id: 8,
    name: 'Logic',
    caption: 'Logik',
    props: { defaultStatementAndLogicNodes: null },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['Logic'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['Logic'],
  },
  {
    id: 9,
    name: 'Redirect',
    caption: 'Weiterleiten',
    props: {
      redirect: '',
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['Redirect'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['Redirect'],
  },
  {
    id: 10,
    name: 'AskChatGPT',
    caption: 'Frage KI',
    props: {
      prompt: null,
      chatGptTaskName: null,
      attachment: [],
      model: 'gpt-4',
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['AskChatGPT'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['AskChatGPT'],
  },
  {
    id: 11,
    name: 'JsonMapper',
    caption: 'Objekt erstellen',
    props: null,
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['JsonMapper'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['JsonMapper'],
  },
  {
    id: 12,
    name: 'Database',
    caption: 'Datensatz schreiben',
    props: {
      operation: null,
      database: null,
      item: {},
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['Database'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['Database'],
  },
  {
    id: 13,
    name: 'GetItem',
    caption: 'Datensatz abrufen',
    props: {
      database: null,
      userInputId: null,
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['GetItem'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['GetItem'],
  },
  {
    id: 14,
    name: 'UpdateItem',
    caption: 'Datensatz aktualisieren',
    props: {
      database: null,
      userInputItemId: null,
      itemContent: [],
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['UpdateItem'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['UpdateItem'],
  },
  {
    id: 15,
    name: 'RemoveItem',
    caption: 'Datensatz löschen',
    props: {
      database: null,
      userInputId: null,
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['RemoveItem'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['RemoveItem'],
  },
  {
    id: 16,
    name: 'Condition',
    caption: 'Entscheidung',
    props: { conditions: null },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
      ...oldCompatibilityData['Condition'].shape,
    },
    previousTaskId: null,
    ...oldCompatibilityData['Condition'],
  },
  {
    id: 4,
    name: 'AILogic',
    caption: 'KI-Logik',
    props: {
      nodes: [],
      language: 'py',
    },
    input: [],
    output: [],
    shape: {
      x: 0,
      y: 0,
    },
    previousTaskId: null,
    ...oldCompatibilityData['AILogic'],
    active: false,
    visible: true,
    status: 'success',
    icon: 'fa fa-code',
    ui: 'Code',
    shape: { type: 'rectangle', width: 215, height: 72, selected: false },
  },
];

export const workFlowTasksMiscData = {
  Form: {
    isDroppable: true,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'form-task-icon.svg',
      width: 90,
      height: 90,
      appearance: 'round',
      iconHeight: 26.31,
      iconWidth: 33.1,
    },
    description: 'Dateneingaben & Auswahl',
    dropzones: ['after', 'before'],
    options: ['left', 'right'],
  },
  Start: {
    isDroppable: false,
    isDeletable: true,
    isActive: false,
    style: {
      icon: 'form-task-icon.svg',
      width: 90,
      height: 90,
      appearance: 'round',
      iconHeight: 26.31,
      iconWidth: 33.1,
    },
    description: 'Start ist Form',
    dropzones: ['after', 'before'],
    options: ['left', 'right'],
  },
  Database: {
    isDroppable: true,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'database-task.svg',
      width: 90,
      height: 90,
      appearance: 'square',
      iconHeight: 28.64,
      iconWidth: 22,
    },
    description: 'Element in einer Datenbank erstellen',
    dropzones: ['before', 'after'],
    options: ['left', 'right'],
  },
  End: {
    isDroppable: true,
    isDeletable: true,
    isActive: false,
    style: {
      icon: 'end-task.svg',
      width: 90,
      height: 90,
      appearance: 'round',
      iconHeight: 24,
      iconWidth: 31,
    },
    description: 'Workflow beenden',
    dropzones: ['before', 'after'],
    options: ['left', 'right'],
  },
  Email: {
    isDroppable: true,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'email-task.svg',
      width: 90,
      height: 90,
      appearance: 'square',
      iconHeight: 22,
      iconWidth: 28,
    },
    description: 'E-Mail-Benachrichtigung senden',
    dropzones: ['before', 'after'],
    options: ['left', 'right'],
  },
  Code: {
    isDroppable: true,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'code-task.svg',
      width: 90,
      height: 90,
      appearance: 'square',
      iconHeight: 23,
      iconWidth: 28,
    },
    description: 'Code-Abschnitt ausführen',
    dropzones: ['before', 'after'],
    options: ['left', 'right'],
  },
  HTML: {
    isDroppable: true,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'page-task.svg',
      width: 90,
      height: 90,
      appearance: 'square',
      iconHeight: 29.36,
      iconWidth: 21,
    },
    description: 'Seite mit Markdown und HTML erstellen',
    dropzones: ['before', 'after'],
    options: ['left', 'right'],
  },
  API: {
    isDroppable: true,
    isDeletable: true,
    isActive: false,
    style: {
      icon: 'api-task.svg',
      width: 90,
      height: 90,
      appearance: 'square',
      iconHeight: 29.23,
      iconWidth: 20.45,
    },
    description: 'Daten in datenbank speichern',
    dropzones: ['before', 'after'],
    options: ['left', 'right'],
  },
  Condition: {
    isDroppable: false,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'condition-task.svg',
      width: 90,
      height: 90,
      appearance: 'square',
      iconHeight: 27.73,
      iconWidth: 26,
    },
    description:
      'Basierend auf einer Bedingung verschiedene Pfade im Workflow wählen.',
    dropzones: ['before', 'true', 'false'],
    options: ['left'],
  },
  PageBuilder: {
    isDroppable: true,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'report-task.svg',
      width: 90,
      height: 90,
      appearance: 'square',
      iconHeight: 24,
      iconWidth: 30,
    },
    description: 'Seite mit Drag & Drop erstellen',
    dropzones: ['before', 'after'],
    options: ['left', 'right'],
  },
  Logic: {
    isDroppable: true,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'logic-task.svg',
      width: 90,
      height: 90,
      appearance: 'square',
      iconHeight: 29,
      iconWidth: 29,
    },
    description: 'Einfache Logik oder Berechnung erstellen',
    dropzones: ['before', 'after'],
    options: ['left', 'right'],
  },
  Redirect: {
    isDroppable: false,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'redirect-task.svg',
      width: 90,
      height: 90,
      appearance: 'round',
      iconHeight: 33,
      iconWidth: 33,
    },
    description: 'Zu einer URL weiterleiten',
    dropzones: ['before'],
    options: ['left'],
  },
  AskChatGPT: {
    isDroppable: true,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'gpt-task.svg',
      width: 90,
      height: 90,
      appearance: 'square',
      iconHeight: 27,
      iconWidth: 26.52,
    },
    description: 'Eine Aufgabe von AI lösen lassen',
    dropzones: ['before', 'after'],
    options: ['left', 'right'],
  },
  JsonMapper: {
    isDroppable: false,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'json-mapper-task.svg',
      width: 90,
      height: 90,
      appearance: 'square',
      iconHeight: 28.36,
      iconWidth: 27.35,
    },
    description: 'Einzelne Elemente in einem JSON-Objekt zusammenführen',
    dropzones: ['before'],
    options: ['left'],
  },
  GetItem: {
    isDroppable: true,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'get-item-task.svg',
      width: 90,
      height: 90,
      appearance: 'square',
      iconHeight: 32.09,
      iconWidth: 25,
    },
    description: 'Element aus einer Datenbank abrufen',
    dropzones: ['before', 'after'],
    options: ['left', 'right'],
  },
  UpdateItem: {
    isDroppable: true,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'update-item-task.svg',
      width: 90,
      height: 90,
      appearance: 'square',
      iconHeight: 32.09,
      iconWidth: 25,
    },
    description: 'Element in einer Datenbank aktualisieren',
    dropzones: ['before', 'after'],
    options: ['left', 'right'],
  },
  RemoveItem: {
    isDroppable: true,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'remove-item-task.svg',
      width: 90,
      height: 90,
      appearance: 'square',
      iconHeight: 32.09,
      iconWidth: 25,
    },
    description: 'Element aus einer Datenbank entfernen',
    dropzones: ['before', 'after'],
    options: ['left', 'right'],
  },
  AILogic: {
    isDroppable: true,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'ai-logic.svg',
      width: 90,
      height: 90,
      appearance: 'square',
      iconHeight: 23,
      iconWidth: 28,
    },
    description: 'Code-Abschnitt ausführen',
    dropzones: ['before', 'after'],
    options: ['left', 'right'],
  },
  SpreadSheet: {
    isDroppable: true,
    isDeletable: true,
    isActive: true,
    style: {
      icon: 'code-task.svg',
      width: 90,
      height: 90,
      appearance: 'square',
      iconHeight: 23,
      iconWidth: 28,
    },
    description: 'Code-Abschnitt ausführen',
    dropzones: ['before', 'after'],
    options: ['left', 'right'],
  },
};

export const workFlowAccessLevel = {
  EXECUTE: 'execute',
  EDIT: 'edit',
  EDIT_CONTENT: 'edit-content',
  OWNER: 'owner',
};

export const workFlowAccessLevels = [
  { name: workFlowAccessLevel.EXECUTE, caption: 'Kann ausführen' },
  { name: workFlowAccessLevel.EDIT, caption: 'Kann bearbeiten' },
  { name: workFlowAccessLevel.EDIT_CONTENT, caption: 'Kann formatieren' },
  { name: workFlowAccessLevel.OWNER, caption: 'Besitzer' },
];

export const workFlowActions = {
  start: 'start',
  download: 'download',
  save: 'save',
  setting: 'setting',
};

export const workFlowTypes = {
  jsonTypes: [
    'timeseries', // timeseries is needed for backwards compatiblility
    'loadprofile',
    'custom',
    'model',
    'object',
    'objectlist',
  ],
  listTypes: ['checkbox'],
};

export const workflowCustomTasksList = ['CustomCode'];

export const newWorkflowDefaultVersion = 3.0;

export const vueBasedDefaultProcessRunnerVersion = 'v8';

export const DEFAULT_FORM_STYLES = {
  placeHolderColor: '#a3a3a3',
  placeholderFont: 'OpenSans-SemiBold',
  labelColor: '#000000',
  inputColor: '#222222',
  inputFont: 'OpenSans-Regular',
  borderRadius: 10,
  borderColor: '#dddddd',
  selectedBorderColor: '#000000',
};
